/* Simple Buy - all behaviour.
   Split out of blocks/shaped-simple-buy.liquid so a JS change is a 36KB
   push instead of resending the whole 66KB block. Shopify only writes
   WHOLE files, so every one-line fix used to cost the entire block.

   The block still owns:
     - the markup
     - the <style> that sets the CSS variables (it needs Liquid)
     - the <script type="application/json" data-spb-data="..."> payload,
       which is the ONLY channel from Liquid into this file

   So there is no Liquid in here and there must never be: this is served
   as a static asset and Liquid tags would ship as literal text.
   Anything the block needs to tell this script goes in that JSON
   payload - add a key there, read it off cfg here.

   MULTI-INSTANCE. boot() runs once per payload element and takes the uid
   from its data-spb-data attribute, so two Simple Buy blocks on one page
   each get their own state instead of fighting over one. data-spb-ready
   guards against double-init if the asset is requested twice.

   shopify:section:load re-runs init because the theme editor re-renders
   sections without a page load - without it, editing any setting leaves
   a dead buy area until the merchant refreshes. */
(function(){

  function boot(node){
    if (node.getAttribute('data-spb-ready')) return;
    node.setAttribute('data-spb-ready', '1');

    var UID = node.getAttribute('data-spb-data');
    var root = document.getElementById('spb-' + UID);
    if (!root) return;

    /* The hero <img> has no src until draw() sets it, and while the photo
       downloads the browser paints the img's alt text (e.g. "Seamless
       Bodysuit | Cocoa") over the placeholder. Transparent text hides that
       flash for sighted users while the alt stays intact for screen readers. */
    var heroImgEl = root.querySelector('.spb-img');
    if (heroImgEl) heroImgEl.style.color = 'transparent';

    function own(sel){
      var el = document.querySelector(sel + '[data-spb-owner="' + UID + '"]');
      if (el && el.parentNode !== document.body) document.body.appendChild(el);
      return el;
    }
    var toast = own('[data-spb-toast]');
    var stick = own('[data-spb-stick]');
    var lb    = own('[data-spb-lb]');

    /* Never fail silently. A malformed payload used to return here with no
       trace, which looks exactly like "the button does nothing" - every
       handler is wired inside draw(), so one bad character disables the
       entire buy area. Every number in the payload is piped through `json`
       so nil cannot produce invalid JSON, and anything that still goes
       wrong is logged rather than swallowed. */
    var cfg;
    try { cfg = JSON.parse(node.textContent); }
    catch (e) {
      console.error('[Simple Buy] settings payload is not valid JSON - the buy area is disabled.', e);
      return;
    }
    if (!cfg || !cfg.colours || !cfg.colours.length){
      console.error('[Simple Buy] no colourways resolved - check the Colourways setting.');
      return;
    }

    if (cfg.takeover) document.documentElement.classList.add('spb-takeover');

    /* VIP EARLY ACCESS (Black Friday 2026). snippets/shaped-vip.liquid sets
       window.ShapedVIP for shoppers who came in on the VIP link, during the
       VIP window only. These figures make the page QUOTE the VIP prices; the
       VIP discount codes that assets/shaped-vip.js puts on the cart are what
       charge them - keep the two in step. Normal shoppers skip all of this. */
    var VIPP = (window.ShapedVIP && window.ShapedVIP.live && window.ShapedVIP.prices)
      ? window.ShapedVIP.prices[String(cfg.currentId)] : null;
    if (VIPP){
      var vipTiers = [];
      [1, 2, 3].forEach(function(n){
        if (!VIPP.tiers[n]) return;
        var t = null;
        cfg.tiers.forEach(function(x){ if (x.n === n) t = x; });
        if (!t) t = { n: n, label: 'Buy ' + n, badge: '' };
        t.each = VIPP.tiers[n];
        if (VIPP.badges && VIPP.badges[n] != null) t.badge = VIPP.badges[n];
        vipTiers.push(t);
      });
      cfg.tiers = vipTiers;
      cfg.showTiers = true;
      var vipTw = root.querySelector('[data-spb-tiers]');
      var vipGrp = vipTw ? vipTw.closest('.spb-group') : null;
      if (vipGrp) vipGrp.hidden = false;
      if (cfg.pair && VIPP.pairSaving != null) cfg.pair.bundleSaving = VIPP.pairSaving;
      root.classList.add('spb-vip');
      if (VIPP.tiers[3]) root.setAttribute('data-svip-body', '');
    }
    /* Photo tiles (block setting "Bundle tiles with photos", always on for VIPs):
       1/2/3 product photos fanned in each tier tile, "Mix any colours" beside the
       heading, and no "ea" on Buy 1. */
    var PHOTOS = !!(VIPP || cfg.tilePhotos);
    if (PHOTOS){
      root.classList.add('spb-photos');
      var phTw = root.querySelector('[data-spb-tiers]');
      var phLbl = phTw && phTw.closest('.spb-group') ? phTw.closest('.spb-group').querySelector('.spb-lbl') : null;
      if (phLbl && cfg.colours.length > 1 && !phLbl.querySelector('.spb-mix')){
        var mix = document.createElement('em'); mix.className = 'spb-mix'; mix.textContent = 'Mix any colours';
        phLbl.appendChild(mix);
      }
    }

    /* Desktop sticky gallery: when the photo plus thumbnail strip is taller
       than the window, a fixed top:24px pins it with the thumbnails below the
       fold forever. A negative top lets it scroll until its bottom is in view,
       then stick. Recomputed on resize and whenever the gallery changes size. */
    (function(){
      var gal = root.querySelector('.spb-gallery');
      if (!gal) return;
      function fit(){
        if (window.innerWidth < 990){ gal.style.top = ''; return; }
        var t = Math.min(24, window.innerHeight - gal.offsetHeight - 16);
        gal.style.top = t + 'px';
      }
      window.addEventListener('resize', fit);
      if (window.ResizeObserver) new ResizeObserver(fit).observe(gal);
      fit();
    })();

    /* ---------- BUNDLE CHECKLIST (Buy 2 / Buy 3) ----------
       Testers lost track of the old "Item 1 / Item 2 / Item 3" strip: one
       shared colour row and one shared size row, re-targeted by a tab, so
       nobody could tell which item they were editing. With more than one
       item the shared rows are hidden and each item gets its own row
       ([data-spb-cl]) with its own colours and sizes. Buy 1 is unchanged.
       The free-delivery bar is moved ABOVE the bundle tiles so it reacts as
       you change bundles. VIP extras are added by assets/shaped-vip.js
       through the 'spb:checklist' event - nothing VIP lives here. */
    (function(){
      var ship = root.querySelector('.spb-ship');
      var tw0 = root.querySelector('[data-spb-tiers]');
      var tgrp = tw0 ? tw0.closest('.spb-group') : null;
      if (ship && tgrp) tgrp.parentNode.insertBefore(ship, tgrp);
      var sl = root.querySelector('[data-spb-slots]');
      if (sl){
        var cl = document.createElement('div');
        cl.className = 'spb-cl'; cl.setAttribute('data-spb-cl', ''); cl.hidden = true;
        sl.parentNode.insertBefore(cl, sl.nextSibling);
      }
    })();

    if (!window.ShapedPayLater && !document.querySelector('script[data-spb-pdp]')){
      var sc = document.createElement('script');
      sc.src = cfg.pdpAsset; sc.defer = true; sc.setAttribute('data-spb-pdp', '1');
      document.head.appendChild(sc);
    }

    var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>';

    var SIZES = (function(){
      var seen = {}, out = [];
      cfg.colours.forEach(function(c){
        c.variants.forEach(function(v){ if (!seen[v.title]){ seen[v.title] = 1; out.push(v.title); } });
      });
      return out;
    })();

    var startColour = 0;
    cfg.colours.forEach(function(c, i){ if (c.id === cfg.currentId) startColour = i; });

    var S = { tier:1, active:0, shot:0, items:[{ c:startColour, s:null, picked:true }], busy:false, flash:-1, swipeAt:0 };
    /* Block setting "Start on tier": open on a bundle instead of Buy 1.
       VIPs open on Buy 1 too (24 Oct) - no VIP override. */
    if (!VIPP && cfg.showTiers && cfg.defaultTier > 1){
      var dt = null; cfg.tiers.forEach(function(x){ if (x.n === cfg.defaultTier) dt = x; });
      if (dt){ S.tier = dt.n; while (S.items.length < dt.n) S.items.push({ c:startColour, s:null, picked:false }); }
    }
    /* Pair-with add-on. Inert unless the block passed a cfg.pair. */
    var PAIR = cfg.pair || null;
    S.pair = { on:false, c:0, s:null, touched:false };
    /* While the add-on's own size guide is open, its answer belongs to the
       add-on. Without this the main handler below would resize the garment. */
    var pairGuideOpen = false;
    /* The photos and the guide are separate closures but have to hand off to
       each other, so each parks its opener here. */
    var sheetBridge = { openGuide:null, openPhotos:null, cameFromPhotos:false };
    var SIZE_MAP_PAIR = (function(){
      var m = {};
      if (!PAIR) return m;
      String(PAIR.sizeMap || '').split(',').forEach(function(bit){
        var kv = bit.split(':');
        if (kv.length !== 2) return;
        var k = kv[0].trim().toUpperCase(), v = kv[1].trim().toUpperCase();
        if (k && v) m[k] = v;
      });
      return m;
    })();
    function pairColour(){ return PAIR ? PAIR.colours[S.pair.c] : null; }
    function pairVariantFor(sz){
      var c = pairColour();
      if (!c || !sz) return null;
      for (var i=0;i<c.variants.length;i++){ if (c.variants[i].title === sz) return c.variants[i]; }
      return null;
    }
    /* Only counts once it is BOTH ticked and resolvable to a real variant,
       so the delivery meter can never promise free delivery off a line that
       will not be added. */
    function pairLine(){
      if (!PAIR || !S.pair.on) return null;
      var v = pairVariantFor(S.pair.s);
      return (v && v.available) ? v : null;
    }
    /* The price to COUNT on the delivery meter. Falls back to the cheapest
       available variant when no size is resolved yet, so ticking the box moves
       the bar immediately - she ticked it, that is the intent. pairLine()
       stays strict, so nothing is ever ADDED on this number. */
    function pairFallback(){
      if (!PAIR) return 0;
      var best = 0, i, k, vs;
      var order = [S.pair.c];
      for (i=0;i<PAIR.colours.length;i++){ if (i !== S.pair.c) order.push(i); }
      for (i=0;i<order.length;i++){
        vs = PAIR.colours[order[i]].variants;
        for (k=0;k<vs.length;k++){
          if (vs[k].available && (!best || vs[k].price < best)) best = vs[k].price;
        }
        if (best) return best;
      }
      return best;
    }
    /* ---- the add-on's price IN THE BUNDLE ----
       A Shopify automatic discount takes `bundleSaving` off the add-on at the
       cart when this garment is bought with it. Every figure the page quotes
       subtracts the same amount, so the card, the totals line, the free-
       delivery meter and the receipt all agree. Keep the setting in step with
       that discount. */
    /* `bundleMaxTier`: the saving only reaches checkout up to this tier. On the
       faja, Kaching's Buy 2 discount sits on the faja lines and Shopify then
       won't count them toward the shorts deal, so above tier 1 the shorts are
       quoted at full price - what the cart actually charges. 0 = any tier. */
    function bundleOff(){
      if (!PAIR) return 0;
      if (S.tier > 1 && kupFor(S.tier)) return PAIR.bundleSaving || 0;
      if (PAIR.bundleMaxTier && S.tier > PAIR.bundleMaxTier) return 0;
      return PAIR.bundleSaving || 0;
    }

    /* ---- Kaching upsell (shorts inside the Buy 2+ bundle) ----
       Above Buy 1 the faja/dress lines carry Kaching's bundle discount, and
       Shopify then won't let the "Shorts bundle" BXGY use them, so the shorts
       price has to come from Kaching itself: an upsell on the Kaching deal
       bar. Kaching only honours it when the cart lines carry its
       `__kaching_bundles` property (main items: {deal,pp,main,id,bar}; upsell:
       {id,deal,upsell}) - found by reading its widget, tested in a real cart
       20 Oct 2026. We read the page's own deal (the hidden widget's
       deal-block-id) through window.kachingBundlesApi, so upsells added or
       removed in Kaching flow through without a theme change. A shorts
       colour that is NOT an upsell on that bar is quoted at full price. */
    var KUP = null;
    function kupFor(tier){
      if (!KUP || !PAIR) return null;
      var t = KUP.byTier[tier]; if (!t) return null;
      var c = pairColour();
      var up = c && t.ups[String(c.id)];
      return up ? { deal:t.deal, bar:t.bar, upsell:up } : null;
    }
    (function loadKaching(){
      if (!PAIR) return;
      var tries = 0;
      function go(){
        var blk = document.querySelector('kaching-bundles-block[deal-block-id]');
        var api = window.kachingBundlesApi;
        if (!blk || !api || typeof api.fetchDeals !== 'function') return false;
        var dealId = blk.getAttribute('deal-block-id');
        var host = blk.closest('kaching-bundle');
        var pid = Number((host && host.getAttribute('product-id')) || (cfg.colours[0] && cfg.colours[0].id));
        Promise.resolve(api.fetchDeals({ productId: pid })).then(function(deals){
          var byTier = {};
          (deals || []).forEach(function(d){
            if (d.id !== dealId) return;
            (d.dealBars || []).forEach(function(b){
              (b.upsells || []).forEach(function(u){
                var t = byTier[b.quantity] || (byTier[b.quantity] = { deal: d.nanoId || d.id, bar: b.id, ups: {} });
                t.ups[String(u.productId)] = u.id;
              });
            });
          });
          KUP = { pp: pid, byTier: byTier };
          draw();
        }).catch(function(e){ console.warn('[Simple Buy] Kaching deals unavailable', e); });
        return true;
      }
      if (!go()){
        var iv = setInterval(function(){ if (go() || ++tries > 30) clearInterval(iv); }, 500);
      }
    })();
    function bundlePrice(v){ return v ? Math.max(0, v.price - bundleOff()) : 0; }

    function pairCents(){
      if (!PAIR || !S.pair.on) return 0;
      var v = pairLine();
      return v ? bundlePrice(v) : Math.max(0, pairFallback() - bundleOff());
    }
    /* Ticked but unresolved is not addable: the CTA asks for the size rather
       than quietly adding the dress alone. */
    function pairReady(){ return !PAIR || !S.pair.on || !!pairLine(); }


    /* Free-delivery bar counts what is ALREADY in the cart, not just this
       selection. cartBase is the live cart subtotal in cents, refreshed on
       load, whenever the theme fires a cart change, and after we add. */
    var cartBase = 0;
    function refreshCartBase(){
      try {
        fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(c){ if (c && typeof c.total_price === 'number'){ cartBase = c.total_price; draw(); } })
          .catch(function(){});
      } catch (e) {}
    }

    function money(cents){
      return cfg.symbol + (cents/100).toLocaleString('en-US', { minimumFractionDigits:2, maximumFractionDigits:2 });
    }
    function whole(cents){ return cfg.symbol + Math.round(cents/100).toLocaleString('en-US'); }
    function tierAt(n){
      for (var i=0;i<cfg.tiers.length;i++){ if (cfg.tiers[i].n === n) return cfg.tiers[i]; }
      return cfg.tiers[0];
    }
    function variantFor(ci, size){
      var vs = cfg.colours[ci].variants;
      for (var i=0;i<vs.length;i++){ if (vs[i].title === size) return vs[i]; }
      return null;
    }
    function q(sel){ return root.querySelector(sel); }
    function shots(){ return cfg.colours[S.items[S.active].c].images; }
    function step(dir){
      var n = shots().length;
      if (n < 2) return false;
      S.shot = (S.shot + dir + n) % n;
      return true;
    }

    var toastTimer = null;
    function say(msg){
      if (!toast) return;
      toast.innerHTML = TICK + '<span></span>';
      toast.querySelector('span').textContent = msg;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function(){ toast.classList.remove('show'); }, 2600);
    }

    /* OPEN rows (block setting "open_rows", 24 Oct): every bundle row is
       open at once - colour + sizes visible, nothing folds, no confirm
       step. New rows start on the next popular colour; picking a size on
       one row suggests that size on the others (tagged "Suggested"). */
    var OPEN = !!cfg.openRows;
    function colourOrder(){
      var nC = cfg.colours.length, order = [];
      (cfg.popularColours || []).forEach(function(nm){
        nm = String(nm).trim().toLowerCase();
        for (var pi = 0; pi < nC; pi++){ if (String(cfg.colours[pi].name).toLowerCase() === nm && order.indexOf(pi) < 0) order.push(pi); }
      });
      var st = S.items[0] ? S.items[0].c : 0;
      for (var k = 0; k < nC; k++){ var c = (st + k) % nC; if (order.indexOf(c) < 0) order.push(c); }
      return order;
    }
    function setTier(n){
      var items = S.items.slice(0, n);
      while (items.length < n){
        if (OPEN){
          var used = items.filter(function(x){ return x.picked; }).map(function(x){ return x.c; });
          var ord = colourOrder(), nc = ord[0];
          for (var oi = 0; oi < ord.length; oi++){ if (used.indexOf(ord[oi]) < 0){ nc = ord[oi]; break; } }
          items.push({ c:nc, s:null, picked:false });
        } else {
          items.push({ c:S.items[0].c, s:null, picked:false });
        }
      }
      S.tier = n; S.items = items; S.active = Math.min(S.active, n-1);
      for (var b=0;b<items.length;b++){ if (isSet(items[b])){ autofillFrom(b); break; } }
      for (var k=0;k<items.length;k++){ if (!isSet(items[k])){ S.active = k; S.clEdit = -1; break; } }
      draw();
    }
    /* ---- auto-fill the rest of a bundle ----
       Once item i has a colour AND size, every other item she hasn't set
       herself gets the SAME size in the NEXT colour along (Midnight M ->
       Cocoa M -> Almond M), skipping colours sold out in that size. Items
       filled this way are flagged `auto` and follow item i if she changes it;
       the moment she edits one herself it stops being auto. */
    /* An item counts as chosen only once SHE has set or confirmed it; an
       auto-filled suggestion still needs one tap ("Confirm"). */
    function isSet(x){ return !!(x && x.picked && x.s && (OPEN || !x.auto)); }
    function confirmAuto(i){
      var it = S.items[i]; if (!it || !it.auto) return;
      it.auto = false; S.flash = i; S.clEdit = -1;
      say(cfg.colours[it.c].name + ' ' + it.s + ' confirmed – ' + S.items.filter(isSet).length + ' of ' + S.tier);
      var next = -1;
      for (var k=0;k<S.items.length;k++){ if (!isSet(S.items[k])){ next = k; break; } }
      if (next > -1) S.active = next;
      draw();
      setTimeout(function(){ S.flash = -1; }, 400);
    }
    function autofillFrom(i){
      var base = S.items[i];
      if (!base || !base.picked || !base.s || S.items.length < 2) return 0;
      var nC = cfg.colours.length, used = [], filled = 0;
      if (OPEN) return 0; /* user, 24 Oct: open rows must NOT auto-select anything */
      if (false){
        for (var ko = 0; ko < S.items.length; ko++){
          var ito = S.items[ko];
          if (ko === i || (ito.s && !ito.auto)) continue;
          var keep = ito.picked ? variantFor(ito.c, base.s) : null, pc = -1;
          if (keep && keep.available) pc = ito.c;
          for (var so = 1; so <= nC && pc < 0; so++){
            var co = (ito.c + so) % nC, vo = variantFor(co, base.s);
            if (vo && vo.available) pc = co;
          }
          if (pc < 0) continue;
          ito.c = pc; ito.s = base.s; ito.picked = true; ito.auto = true; filled++;
        }
        return filled;
      }
      S.items.forEach(function(x){ if (x.picked && !x.auto) used.push(x.c); });
      for (var k=0;k<S.items.length;k++){
        var it = S.items[k];
        if (k === i || (it.picked && !it.auto)) continue;
        var pick = -1, step, c, v;
        for (step=1; step<=nC && pick<0; step++){
          c = (base.c + step) % nC; v = variantFor(c, base.s);
          if (v && v.available && used.indexOf(c) < 0) pick = c;
        }
        for (step=0; step<nC && pick<0; step++){
          c = (base.c + step) % nC; v = variantFor(c, base.s);
          if (v && v.available) pick = c;
        }
        if (pick < 0) continue;
        it.c = pick; it.s = base.s; it.picked = true; it.auto = true;
        used.push(pick); filled++;
      }
      return filled;
    }
    function setColour(i){
      S.clEdit = -1;
      var ci = S.active;
      var it = S.items[ci];
      it.c = i;
      it.picked = true;
      it.auto = false;
      /* Open rows: a suggested row that now shares her new colour moves to
         a colour nobody has, in the same size. */
      if (OPEN){
        var taken = S.items.filter(function(x){ return x.picked && !x.auto; }).map(function(x){ return x.c; });
        S.items.forEach(function(x){
          if (!x.auto || x.c !== i) return;
          var ord = colourOrder();
          for (var oi = 0; oi < ord.length; oi++){
            var vv = x.s ? variantFor(ord[oi], x.s) : null;
            if (taken.indexOf(ord[oi]) < 0 && (!x.s || (vv && vv.available))){ x.c = ord[oi]; taken.push(ord[oi]); break; }
          }
        });
      }
      var v = it.s ? variantFor(i, it.s) : null;
      if (it.s && (!v || !v.available)){
        /* Say why the size vanished - silently clearing it read as a bug. */
        say(it.s + ' is sold out in ' + cfg.colours[i].name + ' - choose another size');
        it.s = null;
      }
      S.shot = 0;
      /* If the colour was the LAST piece - a size was already set (e.g. from the
         size guide, before a colour existed) - the item is now complete: flash
         it, confirm, and advance to the next incomplete item, the same finish
         setSize() does when the size is chosen last. Otherwise just redraw and
         stay here so the shopper picks a size for the colour they just chose. */
      if (it.s){
        S.flash = ci;
        autofillFrom(ci);
        var label = cfg.colours[i].name + ' ' + it.s;
        var done = S.items.filter(isSet).length;
        say(S.tier > 1 ? (label + ' selected – ' + done + ' of ' + S.tier) : (label + ' selected'));
        var next = -1;
        for (var k=0;k<S.items.length;k++){ if (!isSet(S.items[k])){ next = k; break; } }
        if (next > -1) S.active = next;
        draw();
        setTimeout(function(){ S.flash = -1; }, 400);
        return;
      }
      draw();
    }
    function setSize(sz, fromGuide){
      S.clEdit = -1;
      var i = S.active;
      /* A colour must be chosen before a size can be picked by tapping. The
         size guide is the one exception (fromGuide) - it can pre-fill the
         size and let the shopper choose the colour after. */
      if (!S.items[i].picked && !fromGuide){
        say(S.items.length > 1 ? ('Please choose a colour for item ' + (i+1)) : 'Please choose a colour');
        var cw = q('[data-spb-colourwrap]'); if (cw) cw.scrollIntoView({ behavior:'smooth', block:'center' });
        return;
      }
      S.items[i].s = sz;
      S.items[i].auto = false;
      S.flash = i;
      var autoN = S.items[i].picked ? autofillFrom(i) : 0;
      /* Advance to the next item only once THIS item is complete (colour AND
         size). A size set from the guide with no colour keeps you here so you
         still pick the colour, instead of a colour being assumed for you. */
      if (S.items[i].picked){
        var next = -1;
        for (var k=0;k<S.items.length;k++){ if (!isSet(S.items[k])){ next = k; break; } }
        if (next > -1) S.active = next;
      }
      if (!S.items[i].picked){
        say(sz + ' selected – now choose a colour');
      } else {
        var label = cfg.colours[S.items[i].c].name + ' ' + sz;
        var done = S.items.filter(isSet).length;
        if (autoN > 0){
          var rest = S.items.filter(function(x){ return x.auto; }).map(function(x){ return cfg.colours[x.c].name + ' ' + x.s; });
          say(OPEN ? (label + ' selected – ' + rest.join(' + ') + ' suggested') : (label + ' selected – now confirm ' + rest[0]));
        } else {
          say(S.tier > 1 ? (label + ' selected – ' + done + ' of ' + S.tier) : (label + ' selected'));
        }
      }
      /* Re-suggest the add-on size off the new main size. Skipped once she
         has picked one herself, so her choice is never overwritten - the
         hint used to say "we've picked S" while the chip still read M. */
      if (PAIR && !S.pair.touched) S.pair.s = null;
      draw();
      setTimeout(function(){ S.flash = -1; }, 400);
    }

    /* ---------- pick the right size of a photo ----------
       Every image used to come through at width=1600 whatever box it went
       into: an 80px thumb, a 48px swatch and the 42px sticky thumbnail all
       downloaded and DECODED a 1600x2000 bitmap. Bytes on the wire were
       fine (~195KB, Shopify serves WebP) - the cost is decode and memory:
       1600*2000*4 = ~12.8MB of bitmap EACH, about 160MB live across the
       thumb strip and swatches. That is what made scrolling stutter on a
       phone, not the download.

       `thumbs` is the same list at width=200. Use small() for anything that
       is not the hero or the lightbox. */
    function small(colour, i){
      if (colour && colour.thumbs && colour.thumbs[i]) return colour.thumbs[i];
      return (colour && colour.images && colour.images[i]) || '';
    }

    /* The hero's srcset. The in-page hero is ~360 CSS px on a phone and ~560
       on desktop; width=1600 made every swipe decode 2.4 megapixels. This
       lets the device take 540/720/1080/1440 instead. The LIGHTBOX still uses
       `images` at 1600 - it pinch-zooms to full screen and needs them. */
    var HERO_SIZES = '(min-width: 900px) 55vw, 92vw';
    function heroSet(colour, i){
      return (colour && colour.heroes && colour.heroes[i]) || '';
    }
    /* Pick ONE candidate ourselves, for anything that is not the hero element.
       A detached new Image() does not resolve `sizes` the way an element in
       layout does - the warm-up images were still pulling width=1440 while the
       hero took 720, so the swipe arrived at an undecoded photo anyway. Doing
       the arithmetic here means the hero, its peeks and the warm-up all ask
       for the same URL, which is the whole point of warming it. */
    function heroPick(colour, i){
      var ss = heroSet(colour, i);
      var full = (colour && colour.images && colour.images[i]) || '';
      if (!ss) return full;
      var el = q('.spb-img');
      var box = (el && el.clientWidth) || 360;
      var need = box * (window.devicePixelRatio || 1);
      var best = null;
      ss.split(',').forEach(function(part){
        var bits = part.trim().split(/\s+/);
        var w = parseInt(bits[1], 10);
        if (!bits[0] || !w) return;
        if (!best) { best = { w: w, url: bits[0] }; return; }
        /* climb while we are still short, then take the smallest that covers */
        if (best.w < need ? w > best.w : (w >= need && w < best.w)) best = { w: w, url: bits[0] };
      });
      return best ? best.url : full;
    }
    function dressHero(el, colour, i){
      var ss = heroSet(colour, i);
      if (ss){ el.srcset = ss; el.sizes = HERO_SIZES; }
      else { el.removeAttribute('srcset'); }
      el.src = (colour && colour.images && colour.images[i]) || '';
    }
    /* peeks and warm-ups: one explicit URL, no srcset to re-resolve */
    function plainHero(el, colour, i){
      el.removeAttribute('srcset');
      el.removeAttribute('sizes');
      el.src = heroPick(colour, i);
    }

    /* ---------- who is in this photo ----------
       The model is recorded in each photo's ALT TEXT, per photo - not per
       product. Cocoa alone has Aurelia, Soph and Jessica across its shots,
       so any single "model name" setting is wrong for most of the gallery.
       This reads the alt for the shot on screen and hides the badge
       entirely when that photo has no usable alt, because naming the wrong
       person is worse than saying nothing.

       Formats seen in the catalogue:
         "Demi wears M"              -> Demi, M
         "Soph wears Small"          -> Soph, S
         "Aurelia wears size small"  -> Aurelia, S
       Liquid falls back to the PRODUCT TITLE when alt is empty, so most
       photos arrive as "Seamless Sculpt Bodysuit | Cocoa". Those do not
       match the pattern and correctly produce no badge. */
    var SIZE_WORDS = {
      'xxs':'2XS', 'xxsmall':'2XS', 'extraextrasmall':'2XS',
      'xs':'XS', 'xsmall':'XS', 'extrasmall':'XS',
      's':'S', 'small':'S',
      'm':'M', 'medium':'M',
      'l':'L', 'large':'L',
      'xl':'XL', 'xlarge':'XL', 'extralarge':'XL',
      'xxl':'2XL', 'xxlarge':'2XL', '2xl':'2XL',
      'xxxl':'3XL', '3xl':'3XL'
    };
    function readModel(alt){
      if (!alt) return null;
      var m = /^\s*(.+?)\s+wears\s+(?:a\s+)?(?:size\s+)?(.+?)\s*$/i.exec(alt);
      if (!m) return null;
      var name = m[1].trim();
      var raw  = m[2].trim();
      var key  = raw.toLowerCase().replace(/[^a-z0-9]/g, '');
      if (!name || !raw) return null;
      return { name: name, size: SIZE_WORDS[key] || raw.toUpperCase() };
    }


    /* ---------- pair-with ----------
       The size is suggested from the main garment through PAIR.sizeMap and
       stays editable. When the chosen colourway does not stock the mapped
       size we move her to one that does rather than leaving a dead picker -
       Beige stops at L while Midnight goes to XL. */
    function suggestPairSize(){
      var it = S.items[S.active];
      if (!it || !it.s) return null;
      var want = SIZE_MAP_PAIR[String(it.s).toUpperCase()] || it.s;
      if (pairVariantFor(want)) return want;
      for (var i=0;i<PAIR.colours.length;i++){
        var vs = PAIR.colours[i].variants;
        for (var k=0;k<vs.length;k++){
          if (vs[k].title === want && vs[k].available){ S.pair.c = i; return want; }
        }
      }
      return want;
    }

    function drawPair(){
      var wrap = q('[data-spb-pair]');
      if (!wrap) return;
      if (!PAIR || !PAIR.colours || !PAIR.colours.length){ wrap.hidden = true; return; }
      wrap.hidden = false;

      var c = pairColour();
      var main = S.items[S.active];
      if (S.pair.on && !S.pair.s) S.pair.s = suggestPairSize();

      wrap.className = 'spb-pair' + (S.pair.on ? ' on' : '');
      q('[data-spb-pair-toggle]').setAttribute('aria-pressed', S.pair.on ? 'true' : 'false');
      q('[data-spb-pair-body]').hidden = !S.pair.on;
      q('[data-spb-pair-img]').src = c.img || '';
      var shots = (c.images && c.images.length) ? c.images : (c.img ? [c.img] : []);
      var pn = q('[data-spb-pair-photo-n]');
      if (pn){
        var tmpl = PAIR.photosLabel || '';
        pn.textContent = (tmpl && shots.length > 1) ? tmpl.replace('[n]', shots.length) : '';
        pn.hidden = !pn.textContent;
      }
      q('[data-spb-pair-img]').alt = c.title + ' in ' + c.name;
      q('[data-spb-pair-kicker]').textContent = PAIR.kicker || '';
      q('[data-spb-pair-name]').textContent = c.title;
      q('[data-spb-pair-why]').textContent = PAIR.why || '';
      q('[data-spb-pair-clbl]').textContent = PAIR.colourLabel || '';
      q('[data-spb-pair-slbl]').textContent = PAIR.sizeLabel || '';
      q('[data-spb-pair-cwrap]').hidden = PAIR.colours.length < 2;

      /* Price is whatever the variant actually costs. The selected size wins;
         with none chosen yet we show the cheapest in this colourway so the
         card is never blank. */
      var shown = pairVariantFor(S.pair.s);
      if (!shown){
        for (var i=0;i<c.variants.length;i++){
          if (!shown || c.variants[i].price < shown.price) shown = c.variants[i];
        }
      }
      q('[data-spb-pair-now]').textContent = shown ? money(bundlePrice(shown)) : '';
      var wasEl = q('[data-spb-pair-was]');
      var hasWas = shown && shown.compare && shown.compare > bundlePrice(shown);
      wasEl.hidden = !hasWas;
      if (hasWas) wasEl.textContent = money(shown.compare);

      var sw = q('[data-spb-pair-sw]'); sw.innerHTML = '';
      PAIR.colours.forEach(function(pc, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'spb-pair-swb' + (i === S.pair.c ? ' on' : '');
        b.setAttribute('aria-pressed', i === S.pair.c ? 'true' : 'false');
        b.setAttribute('aria-label', pc.name);
        var im = document.createElement('img'); im.src = pc.img; im.alt = '';
        im.loading = 'lazy'; im.decoding = 'async';
        var nm = document.createElement('span'); nm.textContent = pc.name;
        b.appendChild(im); b.appendChild(nm);
        b.onclick = function(){
          S.pair.c = i;
          if (S.pair.s && !pairVariantFor(S.pair.s)) S.pair.s = null;
          draw();
        };
        sw.appendChild(b);
      });

      var all = [];
      PAIR.colours.forEach(function(pc){
        pc.variants.forEach(function(v){ if (all.indexOf(v.title) === -1) all.push(v.title); });
      });
      var box = q('[data-spb-pair-sizes]'); box.innerHTML = '';
      all.forEach(function(sz){
        var v = pairVariantFor(sz);
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = sz;
        b.className = 'spb-pair-size' + (S.pair.s === sz ? ' on' : '');
        if (!v || !v.available){
          b.disabled = true;
          b.setAttribute('aria-label', sz + ', not available in ' + c.name);
        } else {
          b.setAttribute('aria-pressed', S.pair.s === sz ? 'true' : 'false');
          b.onclick = function(){ S.pair.s = sz; S.pair.touched = true; draw(); };
        }
        box.appendChild(b);
      });


      var hint = q('[data-spb-pair-hint]'), msg = '';
      if (S.pair.on && main && main.s){
        var mapped = SIZE_MAP_PAIR[String(main.s).toUpperCase()] || main.s;
        if (S.pair.s && !pairVariantFor(S.pair.s)){
          msg = (PAIR.noteMissing || '').replace('[size]', S.pair.s).replace('[colour]', c.name);
        } else if (mapped !== main.s){
          msg = (PAIR.noteMapped || '').replace('[from]', main.s).replace('[to]', mapped);
        } else if (S.pair.s === mapped){
          msg = (PAIR.noteMatched || '').replace('[size]', main.s);
        }
      }
      hint.hidden = !msg;
      if (msg) hint.textContent = msg;
    }

    function cap(w){ w = String(w || 'item'); return w.charAt(0).toUpperCase() + w.slice(1); }
    function drawChecklist(box){
      box.innerHTML = '';
      var head = document.createElement('div');
      head.className = 'spb-cl-head';
      var hl = document.createElement('span');
      hl.className = 'spb-lbl';
      hl.textContent = 'Choose each ' + (cfg.garmentWord || 'item');
      /* Fit note (block setting size_note, 4 Nov): the Buy 1 size label carries
         it, but that group is hidden on Buy 2/3, so the checklist repeats it. */
      var sn = q('.spb-sizenote');
      if (sn){
        var hw = document.createElement('span');
        hw.style.cssText = 'display:inline-flex;align-items:center;gap:8px;flex-wrap:wrap;min-width:0';
        hw.appendChild(hl); hw.appendChild(sn.cloneNode(true));
        head.appendChild(hw);
      } else {
        head.appendChild(hl);
      }
      var g = q('[data-spb-guide]');
      if (g){
        var gb = document.createElement('button');
        gb.type = 'button'; gb.className = 'spb-guidebtn'; gb.innerHTML = g.innerHTML;
        gb.onclick = function(){ g.click(); };
        head.appendChild(gb);
      }
      box.appendChild(head);
      S.items.forEach(function(it, i){
        var done = isSet(it);
        /* A finished row folds up - including the LAST one - and only
           reopens when tapped (S.clEdit). */
        var open = OPEN || (i === S.active && (!done || S.clEdit === i));
        var row = document.createElement('div');
        row.className = 'spb-cl-row' + (open ? ' open' : '') + (done ? ' done' : '') + (S.flash === i ? ' spb-flash' : '');
        var hb = document.createElement('button');
        hb.type = 'button'; hb.className = 'spb-cl-hd';
        hb.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sum = (OPEN && it.picked) ? (cfg.colours[it.c].name + ' · ' + (it.s || 'choose a size'))
          : done ? (cfg.colours[it.c].name + ' · ' + it.s)
          : it.auto ? (cfg.colours[it.c].name + ' · ' + it.s + ' · tap to confirm')
          : it.picked ? (cfg.colours[it.c].name + ' · choose a size')
          : it.s ? ('Size ' + it.s + ' · choose a colour') : 'Choose a colour and size';
        hb.innerHTML = '<span class="spb-cl-n">' + (done ? TICK : String(i + 1)) + '</span>' +
          '<span class="spb-cl-t"><b></b><span></span></span>' +
          ((it.picked && !open) ? '<img alt="" src="' + small(cfg.colours[it.c], 0) + '">' : '') +
          (open ? '' : '<u>' + (done ? 'Change' : 'Choose') + '</u>');
        hb.querySelector('b').textContent = cap(cfg.garmentWord) + ' ' + (i + 1);
        hb.querySelector('.spb-cl-t span').textContent = sum;
        if (OPEN && it.auto){
          var sg = document.createElement('em'); sg.className = 'spb-cl-sug'; sg.textContent = 'Suggested · tap to change';
          hb.querySelector('.spb-cl-t').appendChild(sg);
        }
        hb.onclick = OPEN ? function(){ if (S.active !== i){ S.active = i; S.shot = 0; draw(); } }
          : function(){ if (S.active !== i || !open){ S.active = i; S.shot = 0; S.clEdit = i; draw(); } };
        row.appendChild(hb);
        if (open){
          var body = document.createElement('div');
          body.className = 'spb-cl-body';
          if (cfg.colours.length > 1){
            var sw = document.createElement('div');
            sw.className = 'spb-swatches';
            cfg.colours.forEach(function(c, ci){
              var chosen = it.picked && ci === it.c;
              var wrap = document.createElement('div');
              wrap.className = 'spb-sw-wrap';
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'spb-sw' + (chosen ? ' on' : '');
              b.setAttribute('aria-label', c.name);
              b.setAttribute('aria-pressed', chosen ? 'true' : 'false');
              var im = document.createElement('img'); im.src = small(c, 0); im.alt = ''; im.decoding = 'async';
              b.appendChild(im);
              b.onclick = function(){ S.active = i; setColour(ci); };
              var nm = document.createElement('span');
              nm.className = 'spb-sw-name' + (chosen ? ' on' : '');
              nm.textContent = c.name;
              wrap.appendChild(b); wrap.appendChild(nm);
              sw.appendChild(wrap);
            });
            body.appendChild(sw);
          }
          /* Every size is tappable until a colour is chosen (a greyed-out row
             reads as "all sold out"); sizes only cross out for the chosen
             colour. Size-first is allowed: the row then asks for the colour. */
          var sz = document.createElement('div');
          sz.className = 'spb-sizes';
          SIZES.forEach(function(label){
            var v = variantFor(it.c, label);
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'spb-size' + (it.s === label ? ' on' : '');
            b.textContent = label;
            if (it.picked && (!v || !v.available)){
              b.disabled = true;
              b.setAttribute('aria-label', label + ', sold out');
            } else {
              b.onclick = function(){ S.active = i; setSize(label, !it.picked); };
            }
            sz.appendChild(b);
          });
          body.appendChild(sz);
          if (it.auto && !OPEN){
            var cf = document.createElement('button');
            cf.type = 'button'; cf.className = 'spb-cl-confirm';
            cf.textContent = 'Confirm ' + cfg.colours[it.c].name + ' · ' + it.s;
            cf.onclick = function(){ confirmAuto(i); };
            var cfn = document.createElement('p'); cfn.className = 'spb-cl-note';
            cfn.textContent = 'We picked the next colour in your size - tap a different colour or size to change it.';
            body.appendChild(cfn); body.appendChild(cf);
          }
          row.appendChild(body);
        }
        box.appendChild(row);
      });
      try { root.dispatchEvent(new CustomEvent('spb:checklist', { bubbles: true, detail: { tier: S.tier, box: box, productId: cfg.currentId } })); } catch (e) {}
    }

    function draw(){
      var item = S.items[S.active];
      var col = cfg.colours[item.c];
      var tier = tierAt(S.tier);
      var total = tier.each * S.tier;
      /* VIP: the free bra, gift and delivery count towards the saving. */
      var vipX = (VIPP && VIPP.extras && VIPP.extras[S.tier]) || 0;
      var saved = Math.max(0, (cfg.compare * S.tier) + vipX - total);

      /* ---- what the basket actually comes to ----
         Once the add-on resolves, every figure on the page that quotes a
         total quotes THIS one - the price row, the saving on the button and
         the sticky bar - so no two of them can disagree. Delivery is
         deliberately NOT folded in: it is conditional, it reverses if she
         unticks, and the meter above already states it in a form she can
         check against her own basket. */
      var basketLine = pairLine();
      var basketNow = total;
      var basketWas = cfg.compare * S.tier + vipX;
      if (basketLine){
        var blWas = (basketLine.compare && basketLine.compare > basketLine.price)
                  ? basketLine.compare : basketLine.price;
        basketNow = total + bundlePrice(basketLine);
        basketWas = (cfg.compare * S.tier) + vipX + blWas;
      }
      var basketSaved = Math.max(0, basketWas - basketNow);
      var imgs = col.images.length ? col.images : [''];
      if (S.shot >= imgs.length) S.shot = 0;

      dressHero(q('.spb-img'), col, S.shot);
      if (imgs.length > 1) {
        /* Warm the neighbours at the SAME srcset the peek will ask for, so
           the swipe finds them decoded instead of starting a decode mid-drag. */
        [-1, 1].forEach(function(nd){
          var nj = (S.shot + nd + imgs.length) % imgs.length;
          if (imgs[nj]) {
            var np = new Image();
            np.src = heroPick(col, nj);
            if (np.decode) np.decode().catch(function(){});
          }
        });
      }
      var cn = q('[data-spb-cname]');
      if (cn){
        if (item.picked){ cn.textContent = col.name; cn.style.color = ''; }
        else { cn.textContent = 'Select a colour'; cn.style.color = '#b3261e'; }
      }

      var dv = q('[data-spb-deliv]');
      if (dv) dv.hidden = cfg.delivHideOn > 0 && S.shot === (cfg.delivHideOn - 1);

      var tt = q('[data-spb-title]');
      if (tt) tt.textContent = cfg.titleColour
        ? (tt.getAttribute('data-base') + ' ' + cfg.titleSep + ' ' + col.name)
        : tt.getAttribute('data-base');

      var dots = q('[data-spb-dots]'); dots.innerHTML = '';
      var thumbs = q('[data-spb-thumbs]'); thumbs.innerHTML = '';
      imgs.forEach(function(u, i){
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'spb-dot' + (i===S.shot ? ' on' : '');
        d.setAttribute('aria-label', 'Photo ' + (i+1));
        d.onclick = function(){ S.shot = i; draw(); };
        dots.appendChild(d);
        var t = document.createElement('button');
        t.type = 'button'; t.className = 'spb-thumb' + (i===S.shot ? ' on' : '');
        t.setAttribute('aria-label', 'Photo ' + (i+1));
        var ti = document.createElement('img'); ti.src = small(col, i); ti.alt = '';
        ti.loading = 'lazy'; ti.decoding = 'async';
        t.appendChild(ti);
        t.onclick = function(){ S.shot = i; draw(); };
        thumbs.appendChild(t);
      });
      dots.hidden = imgs.length < 2;
      thumbs.hidden = imgs.length < 2;

      var sw = q('[data-spb-swatches]'); sw.innerHTML = '';
      q('[data-spb-colourwrap]').hidden = cfg.colours.length < 2;
      cfg.colours.forEach(function(c, i){
        var chosen = item.picked && i===item.c;
        var wrap = document.createElement('div');
        wrap.className = 'spb-sw-wrap';
        wrap.style.cssText = 'display:inline-flex;flex-direction:column;align-items:center;gap:5px;width:54px;';
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'spb-sw' + (chosen ? ' on' : '');
        b.setAttribute('aria-label', c.name);
        b.setAttribute('aria-pressed', chosen ? 'true' : 'false');
        var im = document.createElement('img'); im.src = small(c, 0); im.alt = '';
        im.loading = 'lazy'; im.decoding = 'async';
        b.appendChild(im);
        b.onclick = function(){ setColour(i); };
        var nm = document.createElement('span');
        nm.className = 'spb-sw-name';
        nm.textContent = c.name;
        nm.style.cssText = 'font-size:11px;line-height:1.15;text-align:center;max-width:100%;color:' +
          (chosen ? 'var(--spb-ink)' : 'var(--spb-mut)') + ';font-weight:' + (chosen ? '700' : '500') + ';';
        wrap.appendChild(b); wrap.appendChild(nm);
        sw.appendChild(wrap);
      });

      /* The price row describes the GARMENT, always. The basket is the
         ledger line down by the button. */
      var nowEl = q('[data-spb-now]');
      var wasEl = q('[data-spb-was]'), saveEl = q('[data-spb-save]');
      if (!VIPP){
        /* Price row (board 31, B1, 23 Oct): the price EACH, the full price
           of one crossed out, the saving pill, and the bundle total on its
           own line. */
        nowEl.innerHTML = '';
        nowEl.appendChild(document.createTextNode(money(tier.each)));
        if (S.tier > 1){
          var ea = document.createElement('small'); ea.className = 'spb-now-ea'; ea.textContent = ' each';
          nowEl.appendChild(ea);
        }
        /* Crossed-out price = the full price of ONE (R800), like for like
           with the price each, so the SAVE pill adds up (B1, 23 Oct). */
        wasEl.hidden = !(saved > 0 && cfg.compare > tier.each);
        if (!wasEl.hidden) wasEl.textContent = money(cfg.compare);
        saveEl.hidden = !(saved > 0);
        if (saved > 0) saveEl.textContent = cfg.savePrefix + ' ' + whole(saved);
        var row = nowEl.parentNode, tl = q('[data-spb-totline]');
        if (!tl){
          tl = document.createElement('p'); tl.className = 'spb-totline'; tl.setAttribute('data-spb-totline', '');
          row.parentNode.insertBefore(tl, row.nextSibling);
        }
        /* Always present so the page never jumps when she switches tiers
           (24 Oct). On Buy 1 it nudges towards Buy 2 instead. */
                var fmt = function(c){ return (c % 100) ? money(c) : whole(c); };
        tl.hidden = false;
        tl.classList.toggle('is-nudge', S.tier < 2);
        if (S.tier > 1){
          /* One inline span: the line is a flex box (for the pill), and flex
             would otherwise swallow the spaces round <b>. */
          tl.innerHTML = '<span>Total: <b></b> for ' + S.tier + '</span>';
          tl.querySelector('b').textContent = fmt(total);
        } else {
          /* Buy 1 (board 35, 2C): a soft green promise pill, tick centred. */
          tl.innerHTML = '<span class="spb-promise"><span class="spb-promise-tick" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg></span>' +
            '<span>Hassle-free size exchanges &amp; returns</span></span>';
        }
      } else {
        nowEl.textContent = money(total);
        if (saved > 0){
          wasEl.hidden = false; saveEl.hidden = false;
          wasEl.textContent = money(cfg.compare * S.tier + vipX);
          saveEl.textContent = cfg.savePrefix + ' ' + whole(saved);
        } else { wasEl.hidden = true; saveEl.hidden = true; }
      }

      /* ---- ledger ---- */
      var ledg = q('[data-spb-ledger]');
      if (ledg){
        if (!basketLine){
          ledg.hidden = true;
        } else {
          ledg.hidden = false;
          q('[data-spb-ledger-label]').textContent = (PAIR && PAIR.totalLabel) || 'Total';
          var ledgWas = q('[data-spb-ledger-was]');
          ledgWas.hidden = basketWas <= basketNow;
          ledgWas.textContent = money(basketWas);
          q('[data-spb-ledger-now]').textContent = money(basketNow);
        }
      }

      var tw = q('[data-spb-tiers]'); tw.innerHTML = '';
      cfg.tiers.forEach(function(t){
        if (!t.n || t.n < 1) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'spb-tier' + (t.n===S.tier ? ' on' : '');
        if (t.badge){
          var bg = document.createElement('span');
          bg.className = 'spb-tierbadge' + (/free/i.test(t.badge) ? ' spb-tierbadge--free' : ''); bg.textContent = t.badge;
          b.appendChild(bg);
        }
        /* VIP tiles show 1 / 2 / 3 bodysuits stacked, in the colours she has
           picked so far (the rest filled with other colours, to hint at mixing). */
        if (PHOTOS && cfg.colours.length){
          /* One photo per item: the colour she has actually picked for it,
             otherwise the next colour along from the one on screen, so a
             fresh page shows Midnight + Cocoa (+ Almond), never the same
             colour twice. */
          var nCol = cfg.colours.length, start = S.items[0] ? S.items[0].c : 0, used = [];
          /* `popularColours` (block setting, e.g. "Midnight, Cocoa") lead the
             photos so Buy 2 always shows the two best sellers, whatever page
             she landed on - until she has chosen her own colours. */
          var pop = (cfg.popularColours || []).map(function(nm){
            nm = String(nm).trim().toLowerCase();
            for (var pi = 0; pi < nCol; pi++){ if (String(cfg.colours[pi].name).toLowerCase() === nm) return pi; }
            return -1;
          }).filter(function(x){ return x > -1; });
          for (var j = 0; j < t.n; j++){
            var itj = S.items[j];
            if (itj && isSet(itj)){ used.push(itj.c); continue; }
            var pc = -1;
            for (var pk = 0; t.n > 1 && pk < pop.length && pc < 0; pk++){ if (used.indexOf(pop[pk]) < 0) pc = pop[pk]; }
            if (pc > -1){ used.push(pc); continue; }
            var cc = -1;
            for (var st = 0; st < nCol && cc < 0; st++){
              var cand = (start + j + st) % nCol;
              if (used.indexOf(cand) < 0) cc = cand;
            }
            used.push(cc < 0 ? (start + j) % nCol : cc);
          }
          var stk = document.createElement('span'); stk.className = 'spb-stk';
          used.slice(0, t.n).forEach(function(cc){
            var src = (cfg.colours[cc].images && cfg.colours[cc].images[0]) || '';
            if (!src) return;
            /* wrapped so the photo can be zoomed in on the bodysuit (the product
               shots are full-length on white, which reads tiny at this size) */
            var ph = document.createElement('span'); ph.className = 'spb-ph';
            var im = document.createElement('img');
            im.src = src.replace(/width=[0-9]+/, 'width=240'); im.alt = ''; im.width = 30; im.height = 42; im.loading = 'lazy';
            ph.appendChild(im); stk.appendChild(ph);
          });
          b.appendChild(stk);
        }
        var a = document.createElement('span'); a.className = 'a'; a.textContent = t.label;
        var c2 = document.createElement('span'); c2.className = 'b'; c2.textContent = money(t.each) + ((PHOTOS && t.n === 1) ? '' : ' ea');
        b.appendChild(a); b.appendChild(c2);
        if (VIPP && t.n === 3 && VIPP.tiers[3] && window.ShapedVIP.braPhoto){
          var bp = document.createElement('span'); bp.className = 'spb-brapill';
          bp.innerHTML = '<img src="' + window.ShapedVIP.braPhoto + '" alt="" width="18" height="18"><span>Free bra <i>+ gift</i></span>';
          b.appendChild(bp); b.classList.add('has-brapill');
        }
        /* Small saving line on photo tiles (not on VIP pages, which use their own pills). */
        if (PHOTOS && !VIPP && cfg.compare > t.each){
          var sv = document.createElement('span'); sv.className = 'spb-tsave';
          sv.textContent = 'Save R' + Math.round((cfg.compare - t.each) * t.n / 100).toLocaleString('en-ZA').replace(/[^0-9]/g, ',');
          b.appendChild(sv);
        }
        if (t.perk && !b.classList.contains('has-brapill')){
          var pk = document.createElement('span'); pk.className = 'spb-perk'; pk.textContent = t.perk;
          b.appendChild(pk);
        }
        b.onclick = function(){ setTier(t.n); };
        tw.appendChild(b);
      });

      var slots = q('[data-spb-slots]'); slots.innerHTML = '';
      /* With one item and no bundle tiers this box only repeats the colour
         label and the size heading right below it. */
      slots.hidden = (S.tier === 1 && !cfg.showTiers);
      if (S.tier === 1){
        slots.className = 'spb-slots single';
        var st = document.createElement('div');
        st.className = 'spb-status' + (item.s ? ' done' : '') + (S.flash === 0 ? ' spb-flash' : '');
        st.innerHTML = (item.s ? TICK : '') + '<span></span>';
        st.querySelector('span').textContent = item.s
          ? (col.name + ' · ' + item.s)
          : (col.name + ' · ' + cfg.chooseSize.toLowerCase());
        slots.appendChild(st);
      } else {
        slots.className = 'spb-slots';
        S.items.forEach(function(it, i){
          var complete = it.picked && it.s;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'spb-slot' + (i===S.active ? ' on' : '') + (complete ? ' done' : '')
            + (S.flash === i ? ' spb-flash' : '');
          b.innerHTML = (complete ? TICK : '') + '<span></span>';
          var txt;
          if (it.picked && it.s) txt = cfg.colours[it.c].name + ' · ' + it.s;
          else if (it.picked && !it.s) txt = cfg.colours[it.c].name + ' · choose size';
          else if (!it.picked && it.s) txt = it.s + ' · choose colour';
          else txt = 'Item ' + (i+1);
          b.querySelector('span').textContent = txt;
          b.onclick = function(){ S.active = i; draw(); };
          slots.appendChild(b);
        });
      }

      var szlbl = S.tier > 1 ? (cfg.sizeLabel + ' — item ' + (S.active + 1)) : cfg.sizeLabel;
      q('[data-spb-sizelbl]').textContent = szlbl;

      var sz = q('[data-spb-sizes]'); sz.innerHTML = '';
      SIZES.forEach(function(label){
        var v = variantFor(item.c, label);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'spb-size' + (item.s===label ? ' on' : '');
        b.textContent = label;
        if (item.picked && (!v || !v.available)){
          b.disabled = true;
          b.setAttribute('aria-label', label + ', sold out');
        } else {
          b.onclick = function(){ setSize(label); };
        }
        sz.appendChild(b);
      });


      var checklist = S.tier > 1;
      var sizeGrp = q('[data-spb-sizes]').closest('.spb-group');
      var clBox = q('[data-spb-cl]');
      if (clBox){
        clBox.hidden = !checklist;
        if (sizeGrp) sizeGrp.hidden = checklist;
        if (checklist){
          slots.hidden = true;
          q('[data-spb-colourwrap]').hidden = true;
          drawChecklist(clBox);
        } else {
          clBox.innerHTML = '';
        }
      }

      drawPair();
      if (cfg.freeFrom > 0){
        var msg = q('[data-spb-shipmsg]'), fill = q('[data-spb-fill]');
        var combined = total + cartBase + pairCents();
        var unlocked = combined >= cfg.freeFrom;
        fill.style.width = unlocked ? '100%' : Math.min(100, Math.round(combined / cfg.freeFrom * 100)) + '%';
        fill.className = unlocked ? 'spb-fill done' : 'spb-fill';
        if (unlocked){
          msg.className = 'spb-shipmsg done';
          msg.innerHTML = TICK + '<span></span>';
          msg.querySelector('span').textContent = cfg.shipDone;
        } else {
          msg.className = 'spb-shipmsg';
          /* Only promise it while this ONE add-on would actually close the
             gap - otherwise fall back to the real shortfall. */
          if (PAIR && !S.pair.on && PAIR.shipMore && (combined + pairFallback()) >= cfg.freeFrom){
            msg.innerHTML = '';
            msg.textContent = PAIR.shipMore;
          } else {
            msg.innerHTML = cfg.shipMore.replace('[amount]', '<b>' + money(cfg.freeFrom - combined) + '</b>');
          }
        }
      }

      /* Pay later must divide the WHOLE basket. It was dividing the garment
         price alone, so ticking the shorts left the instalments unchanged and
         understated. */
      var grand = total + pairCents();
      var pjn = q('[data-spb-pjn]'); if (pjn) pjn.textContent = '3 × ' + money(Math.ceil(grand/3));
      var pfx = q('[data-spb-pfx]'); if (pfx) pfx.textContent = '4 × ' + money(Math.floor(grand/4));
      var pinfo = q('[data-spb-payinfo]'); if (pinfo) pinfo.setAttribute('data-amount', grand);


      var mBtn = q('[data-spb-modelbtn]');
      var mPop = q('[data-spb-modelpop]');
      var mt = q('[data-spb-modeltext]');
      if (mBtn){
        var who = readModel((col.alts || [])[S.shot]);
        if (!who){
          mBtn.hidden = true;
          if (mPop) mPop.hidden = true;
          mBtn.setAttribute('aria-expanded', 'false');
        } else {
          mBtn.hidden = false;
          var lbl = mBtn.querySelector('span');
          if (lbl) lbl.textContent = cfg.modelBtnText.replace('[size]', who.size);
          if (mt) mt.textContent = cfg.modelSentence
            .replace('[model]', who.name).replace('[colour]', col.name)
            .replace('[garment]', cfg.garmentWord).replace('[size]', who.size);
        }
      }

      var ready = S.items.every(isSet) && pairReady();
      var cta = q('[data-spb-add]');
      /* Never greyed out (shoppers read grey as broken): when something is
         missing the button stays brown and takes her to it instead. */
      cta.disabled = !!S.busy;
      cta.classList.toggle('is-todo', !ready);
      var hint = q('[data-spb-hint]');
      if (!hint){
        hint = document.createElement('p'); hint.className = 'spb-cta-hint'; hint.setAttribute('data-spb-hint', '');
        hint.setAttribute('role', 'status'); hint.hidden = true;
        cta.parentNode.insertBefore(hint, cta.nextSibling);
      }
      if (ready) hint.hidden = true;
      cta.innerHTML = '';
      if (S.busy){
        cta.textContent = 'Adding…';
      } else if (!ready && item.auto){
        cta.textContent = 'Confirm ' + cap(cfg.garmentWord) + ' ' + (S.active + 1) + ': ' + cfg.colours[item.c].name + ' ' + item.s;
      } else if (!ready){
        if (S.items.every(isSet) && !pairReady()){
          cta.textContent = (PAIR && PAIR.chooseSize) || 'Choose your size';
        } else if (!item.picked){
          cta.textContent = S.tier > 1 ? ('Choose a colour for ' + (cfg.garmentWord || 'item') + ' ' + (S.active + 1)) : 'Choose a colour';
        } else {
          cta.textContent = S.tier > 1 ? cfg.pickSizeFor.replace('[n]', S.active + 1).replace(/\bitem\b/, cfg.garmentWord || 'item') : cfg.chooseSize;
        }
      } else {
        var pl = pairLine();
        var lab = document.createElement('span');
        lab.textContent = (pl && PAIR && PAIR.ctaLabel) ? PAIR.ctaLabel : cfg.ctaLabel;
        cta.appendChild(lab);
        /* Same figure as the price row above - label plus saving only, since
           the amount is already stated there. */
        if (basketSaved > 0 && cfg.ctaSave){
          var sep = document.createElement('span'); sep.className = 'spb-cta-sep';
          var sv = document.createElement('span'); sv.className = 'spb-cta-save';
          sv.textContent = cfg.ctaSave.replace('[amount]', whole(basketSaved));
          cta.appendChild(sep); cta.appendChild(sv);
        }
      }
      cta.onclick = ready ? addToBag : (item.auto ? function(){ confirmAuto(S.active); } : function(){
        var allSet = S.items.every(isSet);
        /* Say WHY in words, under the button, as well as taking her there. */
        var why = (allSet && !pairReady()) ? 'Choose a size for the shorts first'
                : !item.picked ? ('Choose a colour for ' + (S.tier > 1 ? cfg.garmentWord + ' ' + (S.active + 1) : 'your ' + cfg.garmentWord) + ' first')
                : ('Choose a size for ' + (S.tier > 1 ? cfg.garmentWord + ' ' + (S.active + 1) : 'your ' + cfg.garmentWord) + ' first');
        hint.textContent = why + ' ↑'; hint.hidden = false;
        say(why);
        var target = (allSet && !pairReady()) ? q('[data-spb-pair]')
                   : (!item.picked ? q('[data-spb-colourwrap]') : q('[data-spb-sizes]'));
        if (!target) return;
        target.scrollIntoView({ behavior:'smooth', block:'center' });
        target.classList.remove('spb-nudge'); void target.offsetWidth; target.classList.add('spb-nudge');
        setTimeout(function(){ target.classList.remove('spb-nudge'); }, 1600);
      });

      if (stick){
        stick.querySelector('[data-spb-stick-img]').src = small(col, 0);
        var l1 = stick.querySelector('[data-spb-stick1]');
        var l2 = stick.querySelector('[data-spb-stick2]');
        var sbtn = stick.querySelector('[data-spb-stick-btn]');
        var stickItems = S.tier + (basketLine ? 1 : 0);
        l2.innerHTML = '<b>' + money(basketNow) + '</b>' + (stickItems > 1 ? ' · ' + stickItems + ' items' : '');
        if (ready){
          l1.className = 'spb-stick-1';
          var stickBits = S.items.map(function(i){ return cfg.colours[i.c].name + ' ' + i.s; });
          if (basketLine) stickBits.push(pairColour().name + ' ' + S.pair.s);
          l1.textContent = stickBits.join(' + ');
          sbtn.textContent = S.busy ? 'Adding…' : cfg.ctaLabel;
          sbtn.onclick = addToBag;
        } else {
          l1.className = 'spb-stick-1 todo';
          var needPair = S.items.every(isSet) && !pairReady();
          l1.textContent = needPair ? 'Shorts size not chosen'
                         : (!item.picked ? 'Choose a colour' : (col.name + ' · no size chosen'));
          sbtn.textContent = needPair ? ((PAIR && PAIR.chooseSize) || cfg.chooseSize)
                           : (!item.picked ? 'Choose colour' : cfg.chooseSize);
          sbtn.onclick = function(){
            var target = needPair ? q('[data-spb-pair]')
                       : (!item.picked ? q('[data-spb-colourwrap]') : q('[data-spb-sizes]'));
            if (target) target.scrollIntoView({ behavior:'smooth', block:'center' });
          };
        }
      }

      if (lb && lb.classList.contains('open')) drawLightbox();
    }

    /* ---------- the theme's cart drawer ----------
       This theme does NOT use data attributes for either job. It ships two
       custom elements:

         <drawer-cart>             .fetchAndRenderCartItems()  re-renders the
                                   contents AND the header count bubble
         [drawer-to-open="cart-drawer"]   the header cart button, which is what
                                   actually opens <cart-drawer-component>

       Guessing at generic selectors (data-cart-drawer-open, .js-cart-drawer-open)
       matched nothing, so the drawer never opened - and because nothing ever
       called fetchAndRenderCartItems, opening it by hand showed an EMPTY cart
       while /cart.js already held the line. Two separate failures, one symptom.

       Order matters: render first, then open. Opening first shows the stale
       empty state for a beat before it fills in.

       Both steps are optional - if a future theme drops these elements the add
       still succeeds and the toast is still the confirmation. */
    function openCartDrawer(){
      var render = Promise.resolve();
      var dc = document.querySelector('drawer-cart');
      if (dc && typeof dc.fetchAndRenderCartItems === 'function'){
        try { render = Promise.resolve(dc.fetchAndRenderCartItems()); } catch (e) {
          console.warn('[Simple Buy] drawer-cart refresh failed', e);
        }
      }
      render.catch(function(e){
        console.warn('[Simple Buy] drawer-cart refresh rejected', e);
      }).then(function(){
        var opener = document.querySelector('[drawer-to-open="cart-drawer"]');
        if (opener) opener.click();
      });
    }

    function addToBag(){
      if (S.busy) return;
      var lines = [];
      for (var i=0;i<S.items.length;i++){
        var it = S.items[i];
        if (!it.picked){
          S.active = i; draw();
          say(S.items.length > 1 ? ('Please choose a colour for item ' + (i+1)) : 'Please choose a colour');
          var cw = q('[data-spb-colourwrap]'); if (cw) cw.scrollIntoView({ behavior:'smooth', block:'center' });
          return;
        }
        if (!it.s){ S.active = i; draw(); say(cfg.chooseSize); return; }
        var v = variantFor(it.c, it.s);
        if (!v){
          console.error('[Simple Buy] no variant for', cfg.colours[it.c].name, it.s);
          say('That size is unavailable in this colour');
          return;
        }
        lines.push({ id: v.id, quantity: 1 });
      }
      /* The add-on rides on the SAME /cart/add.js call. Two sequential
         posts would race the drawer open on the first one and show a cart
         missing the second line. */
      var pl = pairLine();
      if (pl){
        var kp = kupFor(S.tier);
        var pline = { id: pl.id, quantity: 1 };
        if (kp && S.tier > 1){
          /* Tag the bundle so Kaching prices the shorts (see loadKaching). */
          var kid = 'spb' + Date.now().toString(36);
          lines.forEach(function(l){
            l.properties = { __kaching_bundles: JSON.stringify({ deal: kp.deal, pp: KUP.pp, main: true, id: kid, bar: kp.bar }) };
          });
          pline.properties = { __kaching_bundles: JSON.stringify({ id: kid, deal: kp.deal, upsell: kp.upsell }) };
        }
        lines.push(pline);
      }

      S.busy = true; draw();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines })
      }).then(function(r){
        /* Read the body either way: Shopify puts the real reason in there
           (sold out, variant missing) and bouncing to /cart hid it. */
        return r.json().catch(function(){ return {}; }).then(function(body){
          if (!r.ok) throw new Error(body.description || body.message || ('cart ' + r.status));
          return body;
        });
      }).then(function(){
        S.busy = false; draw();
        say(cfg.toastAdded.replace('[n]', lines.length));
        if (cfg.afterAdd === 'cart'){ window.location.href = '/cart'; return; }
        refreshCartBase();
        openCartDrawer();
      }).catch(function(err){
        S.busy = false; draw();
        console.error('[Simple Buy] add to cart failed', err);
        say(String(err && err.message ? err.message : 'Could not add to bag'));
      });
    }

    (function pairToggle(){
      var btn = q('[data-spb-pair-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function(){
        if (!PAIR) return;
        S.pair.on = !S.pair.on;
        if (S.pair.on) S.pair.s = S.pair.s || suggestPairSize();
        draw();
      });
    })();


    /* ---------- before / after sheet ----------
       Independent of the pair card: its own cfg.ba, its own trigger under the
       size chips. The sheet is built once on first open rather than on every
       draw(), because draw() runs on every tap of a size or a swatch and
       rebuilding four pairs of <img> each time is wasted work. */
    var BA = cfg.ba || null;
    (function beforeAfter(){
      var btn = q('[data-spb-bab]');
      var sheet = own('[data-spb-basheet]');
      if (!btn) return;

      var pairs = BA && BA.pairs ? BA.pairs.filter(function(p){
        return p && p.before && p.after;
      }) : [];
      if (!BA || !pairs.length){ btn.hidden = true; return; }

      btn.hidden = false;
      btn.querySelector('[data-spb-bab-title]').textContent = BA.btnTitle || '';
      btn.querySelector('[data-spb-bab-sub]').textContent = BA.btnSub || '';

      /* two thumbnails on the button so it shows what it opens */
      var mini = btn.querySelector('[data-spb-bab-mini]');
      mini.innerHTML = '';
      [pairs[0].before, pairs[0].after].forEach(function(src){
        var im = document.createElement('img');
        im.src = src; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
        mini.appendChild(im);
      });

      if (!sheet) return;
      sheet.querySelector('[data-spb-basheet-title]').textContent = BA.heading || '';

      var built = false;
      function build(){
        if (built) return;
        built = true;
        var body = sheet.querySelector('[data-spb-basheet-b]');
        body.innerHTML = '';
        pairs.forEach(function(p){
          var row = document.createElement('div');
          row.className = 'spb-bap';
          [[p.before, BA.labelBefore, p.beforeAlt], [p.after, BA.labelAfter, p.afterAlt]]
            .forEach(function(side){
              var fig = document.createElement('figure');
              var im = document.createElement('img');
              im.src = side[0]; im.alt = side[2] || ''; im.loading = 'lazy'; im.decoding = 'async';
              var cap = document.createElement('figcaption');
              cap.textContent = side[1] || '';
              fig.appendChild(im); fig.appendChild(cap);
              row.appendChild(fig);
            });
          var wrap = document.createElement('div');
          wrap.appendChild(row);
          if (p.caption){
            var c = document.createElement('p');
            c.className = 'spb-bap-cap'; c.textContent = p.caption;
            wrap.appendChild(c);
          }
          body.appendChild(wrap);
        });
      }

      var lastFocus = null;
      function open(){
        build();
        lastFocus = document.activeElement;
        sheet.classList.add('open');
        document.body.style.overflow = 'hidden';
        sheet.querySelector('[data-spb-basheet-x]').focus({ preventScroll:true });
      }
      function close(){
        if (!sheet.classList.contains('open')) return;
        sheet.classList.remove('open');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll:true });
      }
      btn.addEventListener('click', open);
      sheet.querySelector('[data-spb-basheet-x]').addEventListener('click', close);
      sheet.addEventListener('click', function(e){ if (e.target === sheet) close(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    })();


    /* ---------- the shorts' own photos ----------
       She is being asked for another R450 on the strength of one 62px
       thumbnail. This opens that colourway's full set, with chips so Beige
       and Midnight can be compared without closing it. Rebuilt on each open
       because the chosen colour may have changed since last time. */
    (function pairPhotos(){
      var btn = q('[data-spb-pair-photo]');
      var sheet = own('[data-spb-psheet]');
      if (!btn || !sheet || !PAIR) { if (btn) btn.hidden = true; return; }

      var titleEl = sheet.querySelector('[data-spb-psheet-title]');
      var swEl = sheet.querySelector('[data-spb-psheet-sw]');
      var bodyEl = sheet.querySelector('[data-spb-psheet-b]');

      function render(){
        var c = pairColour();
        if (!c) return;
        titleEl.textContent = c.title + ' — ' + c.name;

        swEl.innerHTML = '';
        if (PAIR.colours.length > 1){
          PAIR.colours.forEach(function(pc, i){
            var cb = document.createElement('button');
            cb.type = 'button';
            cb.className = 'spb-psheet-c' + (i === S.pair.c ? ' on' : '');
            cb.setAttribute('aria-pressed', i === S.pair.c ? 'true' : 'false');
            var im = document.createElement('img'); im.src = pc.img; im.alt = '';
            var nm = document.createElement('span'); nm.textContent = pc.name;
            cb.appendChild(im); cb.appendChild(nm);
            cb.onclick = function(){
              S.pair.c = i;
              if (S.pair.s && !pairVariantFor(S.pair.s)) S.pair.s = null;
              draw();          /* keep the card behind the sheet in step */
              render();
            };
            swEl.appendChild(cb);
          });
        }
        swEl.hidden = PAIR.colours.length < 2;

        bodyEl.innerHTML = '';
        var shots = (c.images && c.images.length) ? c.images : (c.img ? [c.img] : []);
        shots.forEach(function(src, i){
          var im = document.createElement('img');
          im.src = src;
          im.alt = (c.alts && c.alts[i]) || (c.title + ' in ' + c.name);
          im.loading = i < 2 ? 'eager' : 'lazy';
          im.decoding = 'async';
          bodyEl.appendChild(im);
        });
      }

      var lastFocus = null;
      function open(){
        render();
        lastFocus = document.activeElement;
        sheet.classList.add('open');
        document.body.style.overflow = 'hidden';
        bodyEl.scrollTop = 0;
        sheet.querySelector('[data-spb-psheet-x]').focus({ preventScroll:true });
      }
      function close(){
        if (!sheet.classList.contains('open')) return;
        sheet.classList.remove('open');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll:true });
      }
      btn.addEventListener('click', open);
      sheet.querySelector('[data-spb-psheet-x]').addEventListener('click', close);
      sheet.addEventListener('click', function(e){ if (e.target === sheet) close(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

      sheetBridge.openPhotos = open;
      /* Hand off rather than stack: close the photos, open the guide, and let
         the guide show a back arrow home. */
      /* No hiding here: pairPhotos runs BEFORE pairGuide, so openGuide is
         always null at this point. Liquid only renders this button when a
         guide is configured, and pairGuide hides it if PAIR is missing. */
      var gb = sheet.querySelector('[data-spb-psheet-guide]');
      if (gb){
        gb.addEventListener('click', function(){
          if (!sheetBridge.openGuide){ return; }
          close();
          sheetBridge.cameFromPhotos = true;
          sheetBridge.openGuide();
        });
      }
    })();


    /* ---------- the add-on's size guide ----------
       Same sheet furniture as the photos. The calculator inside fires
       spb:selectSize like every other one, so while this is open that event
       is applied to the ADD-ON and fitFinderSize() stands down - otherwise
       picking a shorts size silently resizes the dress. */
    (function pairGuide(){
      var link = q('[data-spb-pair-guide]');
      var sheet = own('[data-spb-gsheet]');
      if (!link) return;
      if (!sheet || !PAIR){
        link.hidden = true;
        var stray = own('[data-spb-psheet-guide]');
        if (stray) stray.hidden = true;
        return;
      }

      link.hidden = false;
      link.textContent = PAIR.guideLabel || 'Size guide';
      var titleEl = sheet.querySelector('[data-spb-gsheet-title]');
      if (titleEl) titleEl.textContent = PAIR.guideHeading || 'Find your size';

      var lastFocus = null;
      function open(){
        lastFocus = document.activeElement;
        pairGuideOpen = true;
        var bk = sheet.querySelector('[data-spb-gsheet-back]');
        if (bk) bk.hidden = !sheetBridge.cameFromPhotos;
        sheet.classList.add('open');
        document.body.style.overflow = 'hidden';
        sheet.querySelector('[data-spb-gsheet-x]').focus({ preventScroll:true });
      }
      function close(){
        if (!sheet.classList.contains('open')) return;
        pairGuideOpen = false;
        sheet.classList.remove('open');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll:true });
      }
      link.addEventListener('click', function(){ sheetBridge.cameFromPhotos = false; open(); });
      sheetBridge.openGuide = open;
      var back = sheet.querySelector('[data-spb-gsheet-back]');
      if (back) back.addEventListener('click', function(){
        close();
        if (sheetBridge.openPhotos) sheetBridge.openPhotos();
      });
      sheet.querySelector('[data-spb-gsheet-x]').addEventListener('click', close);
      sheet.addEventListener('click', function(e){ if (e.target === sheet) close(); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

      /* Apply the guide's answer to the add-on, then get out of the way.
         stopImmediatePropagation is what actually protects the garment. The
         flag alone was not enough: this listener runs first, close() clears
         the flag synchronously, and fitFinderSize() - registered later on the
         same node - then saw a clear flag and resized the dress anyway.
         Verified on the draft: the dress went L -> S. So we claim the event
         here and close on the next tick. */
      document.addEventListener('spb:selectSize', function(e){
        if (!pairGuideOpen) return;
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        var want = e && e.detail && e.detail.size;
        if (!want) return;
        var canon = String(want).toUpperCase();
        var v = pairVariantFor(canon);
        /* The colourways do not all carry the same sizes - Beige stops at L,
           only Midnight is made in XL. Rather than dead-ending on an answer we
           just gave her, move her to a colour that has it and say so. */
        if (!v || !v.available){
          var moved = -1;
          for (var ci = 0; ci < PAIR.colours.length && moved < 0; ci++){
            if (ci === S.pair.c) continue;
            var vs = PAIR.colours[ci].variants;
            for (var k = 0; k < vs.length; k++){
              if (vs[k].title === canon && vs[k].available){ moved = ci; break; }
            }
          }
          if (moved < 0){
            say(canon + (v ? ' is sold out' : ' is not made in this style'));
            return;
          }
          var wasName = pairColour().name;
          S.pair.c = moved;
          say(canon + ' is only in ' + PAIR.colours[moved].name + ', not ' + wasName);
          v = pairVariantFor(canon);
        }
        S.pair.s = canon;
        S.pair.touched = true;      /* her choice, do not re-suggest over it */
        if (!S.pair.on) S.pair.on = true;
        draw();
        setTimeout(close, 0);       /* keep the flag up until this event is done */
      });
    })();

    (function reviewLink(){
      var a = q('[data-spb-reviewlink]');
      if (!a) return;
      a.addEventListener('click', function(e){
        var t = document.querySelector('[data-sr-config]') ||
                document.getElementById('shaped-reviews') ||
                document.querySelector('.sr-wrap, .shaped-reviews');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior:'smooth', block:'start' });
      });
    })();

    (function model(){
      var btn = q('[data-spb-modelbtn]'), pop = q('[data-spb-modelpop]');
      if (!btn || !pop) return;
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var open = pop.hidden;
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function(e){
        if (pop.hidden) return;
        if (pop.contains(e.target) || btn.contains(e.target)) return;
        pop.hidden = true; btn.setAttribute('aria-expanded','false');
      });
    })();

    (function payinfo(){
      var btn = q('[data-spb-payinfo]'), panel = q('[data-spb-paypanel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function(){
        if (window.ShapedPayLater && window.ShapedPayLater.open) return;
        panel.hidden = !panel.hidden;
        btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      });
    })();

    /* The size-guide calculator can hand a recommended size straight to the
       buy area: it fires spb:selectSize with the size, we map it onto this
       product's size list and select it for the active item. Colour is still
       required before add - the guide only fills the size. */
    (function fitFinderSize(){
      function canon(s){
        var k = String(s).toLowerCase().replace(/[^a-z0-9]/g, '');
        return SIZE_WORDS[k] || String(s).toUpperCase();
      }
      function match(want){
        var wc = canon(want);
        for (var i=0;i<SIZES.length;i++){ if (canon(SIZES[i]) === wc) return SIZES[i]; }
        for (var j=0;j<SIZES.length;j++){ if (SIZES[j] === want) return SIZES[j]; }
        return null;
      }
      document.addEventListener('spb:selectSize', function(e){
        if (pairGuideOpen) return;   /* the add-on's guide owns this answer */
        var want = e && e.detail && e.detail.size;
        if (!want) return;
        var target = match(want);
        if (!target) return;
        var it = S.items[S.active];
        if (it.picked){
          var v = variantFor(it.c, target);
          if (!v || !v.available){
            say(target + ' is sold out in ' + cfg.colours[it.c].name);
            return;
          }
        }
        setSize(target, true);
      });
    })();

    /* Hero swipe - Instagram-style carousel (the small gallery, not the lightbox).
       The current photo AND the neighbouring photos all track the finger at
       once, then the whole group snaps one panel over on release. A single
       <img> can only show one photo, so during a drag the previous and next
       shots are mounted as lightweight "peek" layers overlaid on the hero and
       translated together with it; they are torn down the moment the gesture
       ends, so a page at rest is still just one <img> with no extra compositor
       layers.

       transform only - never `left`/`margin` - so it stays on the compositor.
       Timers only, never nested requestAnimationFrame: a dropped rAF used to
       leave a photo parked off-centre with `locked` stuck on, killing every
       later swipe. A timer always fires, and lockedAt self-heals a stale lock.

       prefers-reduced-motion is honoured: the swipe still changes photo, it
       just cuts instead of sliding. */
    (function heroSwipe(){
      var el = q('[data-spb-hero]');
      if (!el) return;
      var img = el.querySelector('.spb-img');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var SLIDE = 'transform .3s cubic-bezier(.22,.61,.36,1)';
      var x0 = null, y0 = null, horizontal = false, locked = false, lockedAt = 0;
      var prev = null, next = null, w = 1;

      var cs = window.getComputedStyle(img);
      var fit = cs.objectFit || 'cover';
      var radius = cs.borderRadius || '0';
      if (window.getComputedStyle(el).position === 'static') el.style.position = 'relative';
      el.style.overflow = 'hidden';

      function mkPeek(i){
        var p = document.createElement('img');
        p.alt = ''; p.decoding = 'async';
        plainHero(p, cfg.colours[S.items[S.active].c], i);
        p.setAttribute('data-spb-peek', '1');
        p.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:' +
          fit + ';border-radius:' + radius + ';pointer-events:none;';
        el.appendChild(p);
        return p;
      }
      function clearPeek(){
        if (prev){ prev.remove(); prev = null; }
        if (next){ next.remove(); next = null; }
      }
      var lastT = null;
      function place(px, animate){
        var t = (animate && !calm) ? SLIDE : 'none';
        if (t !== lastT){
          lastT = t;
          img.style.transition = t;
          if (prev) prev.style.transition = t;
          if (next) next.style.transition = t;
        }
        img.style.transform = px ? 'translate3d(' + px + 'px,0,0)' : '';
        if (prev) prev.style.transform = 'translate3d(' + (px - w) + 'px,0,0)';
        if (next) next.style.transform = 'translate3d(' + (px + w) + 'px,0,0)';
      }

      /* Drag frames only. Several touchmoves can land in one frame; collapse
         them. Never used for the commit - see cancelDrag() at every exit. */
      var dragPx = null, dragRaf = 0;
      function drag(px){
        dragPx = px;
        if (dragRaf) return;
        dragRaf = requestAnimationFrame(function(){
          dragRaf = 0;
          if (dragPx !== null) place(dragPx, false);
          dragPx = null;
        });
      }
      function cancelDrag(){
        if (dragRaf){ cancelAnimationFrame(dragRaf); dragRaf = 0; }
        dragPx = null;
      }

      /* Everything expensive, done while the finger is still still. */
      function prepare(){
        var n = shots().length;
        w = el.getBoundingClientRect().width || 1;
        clearPeek();
        lastT = null;
        if (n > 1){
          if (S.shot > 0)     prev = mkPeek(S.shot - 1);
          if (S.shot < n - 1) next = mkPeek(S.shot + 1);
        }
        place(0, false);
        wc(true);
      }
      function wc(on){
        var v = on ? 'transform' : 'auto';
        img.style.willChange = v;
        if (prev) prev.style.willChange = v;
        if (next) next.style.willChange = v;
      }
      function endReached(dx){
        var n = shots().length;
        if (n < 2) return true;
        return (dx > 0 && S.shot === 0) || (dx < 0 && S.shot === n - 1);
      }

      el.addEventListener('touchstart', function(e){
        if (locked && Date.now() - lockedAt > 1000){
          locked = false; cancelDrag(); clearPeek(); place(0, false); wc(false);
        }
        if (locked || e.touches.length !== 1 || (e.target.closest && e.target.closest('button'))){ x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; horizontal = false;
        prepare();
      }, { passive:true });

      el.addEventListener('touchmove', function(e){
        if (x0 === null) return;
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (!horizontal){
          /* the peeks and the layers already exist - see prepare() */
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) horizontal = true;
          else return;
        }
        /* damp only when pulling past the first/last photo, so the end of the
           roll is felt rather than hard-stopped */
        drag(endReached(dx) ? dx * 0.32 : dx);
      }, { passive:true });

      el.addEventListener('touchend', function(e){
        cancelDrag();
        if (x0 === null) return;
        if (!horizontal){ x0 = null; clearPeek(); wc(false); return; }
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;

        if (Math.abs(dx) < 40 || endReached(dx) || shots().length < 2){
          place(0, true);                     /* spring back */
          setTimeout(function(){ clearPeek(); wc(false); }, 340);
          return;
        }

        S.swipeAt = Date.now();
        var dir = dx < 0 ? 1 : -1;

        if (calm){
          step(dir); draw(); place(0, false); clearPeek(); wc(false); return;
        }

        locked = true; lockedAt = Date.now();
        /* slide the whole group one panel over: the current photo leaves and
           the incoming peek lands dead centre */
        place(-dir * w, true);
        setTimeout(function(){
          step(dir);
          img.style.transition = 'none';
          dressHero(img, cfg.colours[S.items[S.active].c], S.shot);  /* == the incoming peek, already decoded */
          img.style.transform = '';
          clearPeek();
          wc(false);
          draw();                             /* sync dots, thumbs, badges, model */
          locked = false;
        }, 320);
      }, { passive:true });    })();

    /* Desktop arrows - phones have the swipe, but a mouse needs click targets
       to move through the photos. Injected here so the block markup stays
       unchanged; they navigate with step()+draw() and show only at the
       desktop breakpoint. */
    (function galleryArrows(){
      var el = q('[data-spb-hero]');
      if (!el) return;
      if (window.getComputedStyle(el).position === 'static') el.style.position = 'relative';
      var mq = window.matchMedia('(min-width: 990px)');
      function mkArrow(dir){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'spb-arrow';
        b.setAttribute('aria-label', dir < 0 ? 'Previous photo' : 'Next photo');
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
          (dir < 0 ? '<path d="M15 18L9 12L15 6"/>' : '<path d="M9 6L15 12L9 18"/>') + '</svg>';
        b.style.cssText = 'position:absolute;top:50%;' + (dir < 0 ? 'left:10px;' : 'right:10px;') +
          'transform:translateY(-50%);z-index:5;width:40px;height:40px;border:0;border-radius:999px;' +
          'background:rgba(255,255,255,.92);color:#1E1E1E;cursor:pointer;display:grid;place-items:center;' +
          'padding:0;box-shadow:0 2px 10px rgba(0,0,0,.14);';
        var svg = b.querySelector('svg'); if (svg) svg.style.cssText = 'width:20px;height:20px;';
        b.addEventListener('click', function(ev){ ev.stopPropagation(); if (step(dir)) draw(); });
        el.appendChild(b);
        return b;
      }
      var prevA = mkArrow(-1), nextA = mkArrow(1);
      function sync(){
        var show = mq.matches && shots().length > 1;
        prevA.style.display = show ? 'grid' : 'none';
        nextA.style.display = show ? 'grid' : 'none';
      }
      sync();
      if (mq.addEventListener) mq.addEventListener('change', sync);
      else if (mq.addListener) mq.addListener(sync);
      window.addEventListener('resize', sync);
    })();

    /* ================= LIGHTBOX ================= */
    var Z = { s:1, x:0, y:0, last:null };
    var MAXZ = cfg.maxZoom || 4, TAPZ = 2.5;

    function drawLightbox(){
      var imgs = shots();
      lb.querySelector('[data-spb-lb-img]').src = imgs[S.shot] || imgs[0];
      var d = lb.querySelector('[data-spb-lb-dots]'); d.innerHTML = '';
      imgs.forEach(function(u, i){
        var b = document.createElement('button');
        b.type='button'; b.className = 'spb-lb-dot' + (i===S.shot ? ' on' : '');
        b.setAttribute('aria-label','Photo ' + (i+1));
        b.onclick = function(e){ e.stopPropagation(); S.shot = i; resetZoom(); draw(); drawLightbox(); };
        d.appendChild(b);
      });
    }

    if (lb){
      var zimg = lb.querySelector('[data-spb-lb-img]');

      var applyZoom = function(animate){
        zimg.style.transition = animate ? 'transform .2s ease' : 'none';
        zimg.style.transform = 'translate(' + Z.x + 'px,' + Z.y + 'px) scale(' + Z.s + ')';
        zimg.classList.toggle('zoomed', Z.s > 1.01);
      };
      var resetZoom = function(animate){
        Z.s = 1; Z.x = 0; Z.y = 0; applyZoom(animate !== false);
      };
      /* Clamp against the LAYOUT size times the scale. getBoundingClientRect
         already includes the transform, so using it would make the limits
         drift on every move. */
      var clampPan = function(){
        var w = zimg.offsetWidth * Z.s, h = zimg.offsetHeight * Z.s;
        var mx = Math.max(0, (w - window.innerWidth) / 2);
        var my = Math.max(0, (h - window.innerHeight) / 2);
        Z.x = Math.max(-mx, Math.min(mx, Z.x));
        Z.y = Math.max(-my, Math.min(my, Z.y));
      };
      var zoomTo = function(scale, cx, cy){
        var r = zimg.getBoundingClientRect();
        Z.s = Math.min(MAXZ, Math.max(1, scale));
        if (Z.s <= 1.01){ resetZoom(); return; }
        Z.x = (r.left + r.width/2 - cx) * (Z.s - 1);
        Z.y = (r.top + r.height/2 - cy) * (Z.s - 1);
        clampPan(); applyZoom(true);
      };
      var openZoom = function(){
        if (Date.now() - S.swipeAt < 350) return;
        Z.last = document.activeElement;
        resetZoom(false); drawLightbox();
        lb.classList.add('open');
        document.body.style.overflow = 'hidden';
        lb.querySelector('[data-spb-lb-close]').focus({ preventScroll:true });
      };
      var closeZoom = function(){
        if (!lb.classList.contains('open')) return;
        lb.classList.remove('open');
        document.body.style.overflow = '';
        resetZoom(false);
        if (Z.last && Z.last.focus) Z.last.focus({ preventScroll:true });
      };

      q('.spb-img').addEventListener('click', openZoom);
      var zh = q('[data-spb-zoom]');
      if (zh) zh.addEventListener('click', function(e){ e.stopPropagation(); openZoom(); });
      lb.querySelector('[data-spb-lb-close]').addEventListener('click', function(e){ e.stopPropagation(); closeZoom(); });
      lb.addEventListener('click', function(e){
        if (e.target === lb || e.target.classList.contains('spb-lb-stage')) closeZoom();
      });
      document.addEventListener('keydown', function(e){
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') closeZoom();
        if (e.key === 'ArrowRight' && Z.s <= 1.01 && step(1)){ draw(); drawLightbox(); }
        if (e.key === 'ArrowLeft'  && Z.s <= 1.01 && step(-1)){ draw(); drawLightbox(); }
      });

      /* ---- touch: pinch / pan / swipe / double-tap ---- */
      var dist = function(t){
        var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
        return Math.sqrt(dx*dx + dy*dy);
      };
      var mid = function(t){
        return { x:(t[0].clientX + t[1].clientX)/2, y:(t[0].clientY + t[1].clientY)/2 };
      };
      var g = null, lastTap = 0;

      zimg.addEventListener('touchstart', function(e){
        if (e.touches.length === 2){
          g = { k:'pinch', d0:dist(e.touches), s0:Z.s, m0:mid(e.touches), x0:Z.x, y0:Z.y };
        } else if (e.touches.length === 1){
          g = { k:'one', x:e.touches[0].clientX, y:e.touches[0].clientY,
                x0:Z.x, y0:Z.y, moved:false };
        }
      }, { passive:true });

      zimg.addEventListener('touchmove', function(e){
        if (!g) return;
        if (g.k === 'pinch' && e.touches.length === 2){
          var m = mid(e.touches);
          Z.s = Math.min(MAXZ, Math.max(1, g.s0 * (dist(e.touches) / g.d0)));
          Z.x = g.x0 + (m.x - g.m0.x);
          Z.y = g.y0 + (m.y - g.m0.y);
          clampPan(); applyZoom(false);
        } else if (g.k === 'one' && e.touches.length === 1){
          var dx = e.touches[0].clientX - g.x, dy = e.touches[0].clientY - g.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) g.moved = true;
          if (Z.s > 1.01){
            Z.x = g.x0 + dx; Z.y = g.y0 + dy;
            clampPan(); applyZoom(false);
          }
        }
      }, { passive:true });

      zimg.addEventListener('touchend', function(e){
        if (!g) return;
        var was = g;
        if (e.touches.length > 0){ g = null; return; }   // a finger lifted mid-pinch
        g = null;

        if (was.k === 'pinch'){
          if (Z.s <= 1.08) resetZoom(true); else { clampPan(); applyZoom(true); }
          return;
        }
        var dx = e.changedTouches[0].clientX - was.x;
        var dy = e.changedTouches[0].clientY - was.y;

        if (!was.moved){
          var now = Date.now();
          if (now - lastTap < 300){
            lastTap = 0;
            if (Z.s > 1.01) resetZoom(true);
            else zoomTo(TAPZ, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
          } else {
            lastTap = now;
          }
          return;
        }
        /* Only swipe photos while fitted - once zoomed the drag was a pan. */
        if (Z.s <= 1.01 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)){
          if (step(dx < 0 ? 1 : -1)){ resetZoom(false); draw(); drawLightbox(); }
        }
      }, { passive:true });

      /* ---- mouse only ---- */
      var down = null, moved = false;
      zimg.addEventListener('pointerdown', function(e){
        if (e.pointerType === 'touch') return;
        down = { x:e.clientX, y:e.clientY, ox:Z.x, oy:Z.y }; moved = false;
        if (Z.s > 1.01) zimg.setPointerCapture(e.pointerId);
      });
      zimg.addEventListener('pointermove', function(e){
        if (!down || e.pointerType === 'touch') return;
        var dx = e.clientX - down.x, dy = e.clientY - down.y;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
        if (Z.s <= 1.01) return;
        Z.x = down.ox + dx; Z.y = down.oy + dy;
        clampPan(); applyZoom(false);
      });
      zimg.addEventListener('pointerup', function(e){
        if (e.pointerType === 'touch') return;
        var start = down; down = null;
        if (moved){
          if (Z.s <= 1.01 && start){
            var dx = e.clientX - start.x, dy = e.clientY - start.y;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && step(dx < 0 ? 1 : -1)){
              draw(); drawLightbox();
            }
          }
          return;
        }
        if (Z.s > 1.01) resetZoom(true); else zoomTo(TAPZ, e.clientX, e.clientY);
      });
      zimg.addEventListener('click', function(e){ e.stopPropagation(); });
      window.addEventListener('resize', function(){ if (Z.s > 1.01){ clampPan(); applyZoom(false); } });
    }

    var guide = q('[data-spb-guide]');
    if (guide) guide.addEventListener('click', function(){
      var d = document.querySelector('[id^="size-guide-drawer-"]');
      if (!d) return;
      d.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });

    /* ---------- dispatch cut-off ----------
       Africa/Johannesburg (UTC+2, no DST), NOT the visitor's clock. */
    (function delivery(){
      var etaEl = q('[data-spb-eta]'), cutEl = q('[data-spb-cut]');
      if (!etaEl && !cutEl) return;
      var textEl = cutEl ? cutEl.querySelector('[data-spb-cuttext]') : null;

      function sast(){
        var d = new Date();
        return new Date(d.getTime() + d.getTimezoneOffset()*60000 + 2*3600000);
      }
      function shipsToday(n){
        var w = n.getDay();
        return w !== 0 && w !== 6 && n.getHours() < cfg.cutoffHour;
      }
      function nextDispatch(n){
        var c = new Date(n.getTime());
        c.setHours(cfg.cutoffHour, 0, 0, 0);
        while (c <= n || c.getDay() === 0 || c.getDay() === 6) c.setDate(c.getDate() + 1);
        return c;
      }
      function addBiz(from, days){
        var o = new Date(from.getTime());
        while (days > 0){ o.setDate(o.getDate()+1); var w = o.getDay(); if (w !== 0 && w !== 6) days--; }
        return o;
      }
      function fmtDate(d){ return d.toLocaleDateString('en-ZA', { weekday:'short', day:'numeric', month:'short' }); }
      function fmtLeft(mins){
        var h = Math.floor(mins/60), m = mins % 60;
        if (h <= 0) return m + 'min';
        return h + (h === 1 ? 'hr ' : 'hrs ') + m + 'min';
      }

      function tick(){
        var now = sast();
        var today = shipsToday(now);
        var from = today ? now : nextDispatch(now);

        if (etaEl){
          etaEl.textContent = cfg.etaPrefix + ' ' + fmtDate(addBiz(from, cfg.etaMin)) +
            ' – ' + fmtDate(addBiz(from, cfg.etaMax));
        }
        if (!cutEl) return;
        if (!today){ cutEl.hidden = true; return; }
        var cut = new Date(now.getTime());
        cut.setHours(cfg.cutoffHour, 0, 0, 0);
        var ms = cut - now;
        if (ms <= 0){ cutEl.hidden = true; return; }
        cutEl.hidden = false;
        if (!textEl) return;
        textEl.textContent = '';
        var parts = cfg.cutoffCopy.split('[time]');
        textEl.appendChild(document.createTextNode(parts[0] || ''));
        var b = document.createElement('b');
        b.textContent = fmtLeft(Math.floor(ms / 60000));
        textEl.appendChild(b);
        textEl.appendChild(document.createTextNode(parts[1] || ''));
      }
      tick();
      setInterval(tick, 30000);
    })();

    /* Sticky bar: rAF-throttled rect check, NOT IntersectionObserver.
       Also hidden while an overlay is up - the lightbox, or the cart drawer.
       The cart drawer is <cart-drawer-component>, which flips aria-hidden to
       "false" when open (the same pattern as the size-guide drawer above), so
       we watch that attribute and re-check on open/close: there is no scroll
       event to piggyback on because the open drawer locks the body. */
    (function watch(){
      if (!stick) return;
      var btn = q('[data-spb-add]');
      var queued = false;
      function drawerOpen(){
        var d = document.querySelector('cart-drawer-component');
        return !!(d && d.getAttribute('aria-hidden') === 'false');
      }
      function check(){
        queued = false;
        var r = btn.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < (window.innerHeight || 0);
        /* Not on page load: only once the shopper has scrolled a little. */
        var scrolled = (window.pageYOffset || document.documentElement.scrollTop || 0) > 250;
        stick.classList.toggle('show', scrolled && !visible && !(lb && lb.classList.contains('open')) && !drawerOpen());
      }
      function ping(){ if (!queued){ queued = true; requestAnimationFrame(check); } }
      window.addEventListener('scroll', ping, { passive:true });
      window.addEventListener('resize', ping);
      document.addEventListener('action:showDrawer', ping);
      var cd = document.querySelector('cart-drawer-component');
      if (cd && window.MutationObserver){
        new MutationObserver(ping).observe(cd, { attributes:true, attributeFilter:['aria-hidden'] });
      }
      ping(); setTimeout(ping, 500);
    })();

    refreshCartBase();
    document.addEventListener('action:cart:updateCart', refreshCartBase);

    draw();
  }

  function init(){
    var nodes = document.querySelectorAll('script[data-spb-data]');
    for (var i = 0; i < nodes.length; i++) boot(nodes[i]);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();